module.exports = __webpack_public_path__ + "img/Abschnittsleiter_Feuerwehr.af74f722.svg";